import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
    refundBody,
    refund_sanction_body
} from '../../models/Accounts';
import { PromiseResult } from '../../models/PromiseResult';
import { PaginationModel } from '../../models/util.models';
import { RestApi } from '../../shared/apiUrls';

@Injectable({
    providedIn: 'root'
})
export class PatientRefundService {
    constructor(private readonly http: HttpClient) {}

    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }

    fetchAllRefunds(body: PaginationModel): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.AdminApis + 'payments/refund/fetchAll',
                body
            )
            .pipe(catchError(this.handleError));
    }

    fetch(refund_id: string): Observable<PromiseResult> {
        return this.http
            .get<PromiseResult>(
                RestApi.Urls.AdminApis + 'payments/refund/fetch/' + refund_id
            )
            .pipe(catchError(this.handleError));
    }

    sanction(body: refund_sanction_body): Observable<PromiseResult> {
        return this.http
            .put<PromiseResult>(
                RestApi.Urls.AdminApis + 'payments/refund/sanction',
                body
            )
            .pipe(catchError(this.handleError));
    }

    refund(body: refundBody): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.AdminApis + 'payments/refund',
                body
            )
            .pipe(catchError(this.handleError));
    }
}
